import React, {Fragment, useState, useEffect, useContext} from "react";
import queryString from "query-string";
import useModalAddPost from "../../../../Modals/AddPost/useModalAddPost";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import {useLocation} from "react-router-dom";
import {getUserPosts, getPostsForApproval, getSentPostsForUser} from "root/DataFunctions/PostDataFns";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";
import {childNameAtom} from "root/recoil/childName";
import PostsTable from "root/Tables/PostsTable";
import {PostFilters, MessageType, UserTypes} from "root/DataFunctions/Constants";
import useModalApprovePost from "root/Modals/ApprovePost/useModalApprovePost";
import {returnedPostCountAtom} from "root/recoil/returnedPostCount";
import {useSetRecoilState} from "recoil";
import GlobalContext from "root/contexts/GlobalContext";

const PostsTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});
    const setReturnedPostCount = useSetRecoilState(returnedPostCountAtom);
    const globals = useContext(GlobalContext);

    const [renderAddPostModal, showAddPostModal] = useModalAddPost((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const [renderApprovePostModal, showApprovePostModal] = useModalApprovePost((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const postFilterDefault = globals.userType === UserTypes.CHILD ? 'incomming' : 'new';
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const postFilter = queryParams.type === undefined ? postFilterDefault : queryParams.type;

    //Get child's data and set the global child name used by the various body header
    const setChildName = useSetRecoilState(childNameAtom);

    //Get the list of posts data
    useEffect(() => {
        getData();
    }, [postFilter, props.child_uid]);

    const checkSeeAllPosts = () =>
    {
        //This will enable us to bring back all messages sent to specified child (not just the ones we sent) if we are an editor for the selected child.
        let seeAllPosts = props.is_editor ? 'all' : 'current';
        return seeAllPosts;
    }

    const getChildId = () =>
    {
        return props.child_uid;
    }

    const getData = () => {
        if (props.child_uid !== null)
        {
            if (postFilter === 'pending')
            {
                getPostsForApproval((response) =>
                {
                    const data = getDataFromResponse(response);
                    setData({isLoading: false, data: data});
                });
            }
            else
            {
                if (props.child_uid === 'all')
                {
                    getUserPosts(postFilter, (response) =>
                    {
                        const data = getDataFromResponse(response);
                        setData({isLoading: false, data: data});

                        //Count any returned messages
                        if (postFilter === PostFilters.DISCUSSING)
                        {
                            const counter = data.length;
                            // Set the recoil unread message Atom
                            setReturnedPostCount(counter);
                        }
                    });
                }
                else
                {
                    getSentPostsForUser(props.child_uid, postFilter, checkSeeAllPosts(), (response) =>
                    {
                        const data = getDataFromResponse(response);
                        setData({isLoading: false, data: data});

                        //Count any returned messages
                        if (postFilter === PostFilters.DISCUSSING)
                        {
                            const counter = data.length;
                            // Set the recoil unread message Atom
                            setReturnedPostCount(counter);
                        }
                    });
                }
            }
        }
    };

    useEffect(() => {
        getChildData();
    }, [props.child_uid]);

    const getChildData = () => {
        if (props.child_uid !== 'all')
        {
            getChildDetails(props.child_uid, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const clickHandler = (mode, child_uid, post_id) =>
    {
        switch (mode)
        {
            case 'create':
            case 'view':
            case 'edit':
            case'delete':
                showAddPostModal(mode, child_uid, post_id, null, MessageType.MESSAGE_TYPE_LIFESTORY);
                break;

            case 'Action':
            case 'Hold Back':
                showApprovePostModal(mode, child_uid, post_id, MessageType.MESSAGE_TYPE_LIFESTORY);
                break;
        }
    }

    const myPostsTable = () => {
        return (
            <Fragment>
                <div className="post-body">
                    <PostsTable child_uid={props.child_uid} loading={data.loading} data={data.data}
                                clickHandler={clickHandler} messageType={MessageType.MESSAGE_TYPE_LIFESTORY}/>
                    <section>
                        {/* don't show create button if child not selected */}
                        {props.child_uid !== 'all' &&
                            <ActionButton icon='icon-add' onClick={() => clickHandler('create', getChildId(), null)}
                                          title="New Post"/>}
                    </section>
                </div>

                {renderApprovePostModal(props)}
                {renderAddPostModal()}
            </Fragment>
        )
    }

    const tableSection = () =>
    {
        return myPostsTable();
    }

    return (
        <Fragment>
            {tableSection()}
        </Fragment>
    )
}

PostsTab.defaultProps = {};

export default PostsTab;

